import React, {useState} from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import {customerLogin} from "../actions/ApiCalls";
import {useNavigate} from "react-router-dom";

function CustomerLogin() {
    const [customerCode, setCustomerCode] = useState<string>('');

    const navigate = useNavigate();

    function handleSubmit(e: React.FormEvent) {
        e.preventDefault();

        customerLogin(customerCode)
            .then(response => {
                localStorage.setItem('customer_code', response.data.data.customer_code);
                navigate('/our-wines')

            })
            .catch(error => {
                console.error("Failed to fetch filtered products:", error);
            }
            )
    }
    return <div style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        width: '100%',
        // overflow: 'hidden'
    }}>
    <Header />
        <div style={{minHeight: window.innerWidth > 575 ? '700px' : '350px'}}>
            <div style={{display: 'flex', flexDirection: window.innerWidth > 575 ? 'row' : 'column', gap: '20px', padding: window.innerWidth > 575 ? 0 : '24px', marginTop: '140px' }}>
                <div style={{flex: 1}}></div>
                <div style={{flex: 1, textAlign: 'left', marginLeft: window.innerWidth > 575 ? '36px' : 0}}>
                    <form className="content-form" onSubmit={handleSubmit}>
                        <p style={{fontWeight: 600, textTransform: 'uppercase'}}>
                            LOGIN
                        </p>
                        <p style={{width: window.innerWidth > 575 ? '65%' : '100%', marginBottom: '10px'}}>
                            By entering your Customer Code, you will have access to the priced Vinimark Portfolio.
                        </p>
                        <div className="content-form-field" style={{width: window.innerWidth > 575 ? '65%' : '100%'}}>
                            <input
                                type="text"
                                className="input-email"
                                placeholder="Enter Customer Code"
                                value={customerCode}
                                onChange={(e) => setCustomerCode(e.target.value)}
                                required
                            />
                        </div>
                        <div className="content-form-button" style={{width: window.innerWidth > 575 ? '65%' : '100%'}}>
                            <button className="button" style={{width: '100%'}} type="submit">Login</button>
                        </div>
                    </form>

                </div>
            </div>
        </div>
        <Footer />
    </div>


}

export default CustomerLogin;
